import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TeamService } from 'src/app/shared/team.service';
import { TeamDetails } from '../models/team';

import { MatButtonToggleGroup, MatButtonToggle } from '@angular/material/button-toggle';
import { TeamLoadlevelChartComponent } from '../team-loadlevel-chart/team-loadlevel-chart.component';
import { TeamLoadlevelincreaseChartComponent } from '../team-loadlevelincrease-chart/team-loadlevelincrease-chart.component';
import { TeamLoadlevelACWRChartComponent } from '../team-loadlevel-acwrchart/team-loadlevel-acwrchart.component';

@Component({
    selector: 'app-team-loadlevel-analysis',
    templateUrl: './team-loadlevel-analysis.component.html',
    styleUrls: ['./team-loadlevel-analysis.component.css'],
    imports: [MatButtonToggleGroup, MatButtonToggle, TeamLoadlevelChartComponent, TeamLoadlevelincreaseChartComponent, TeamLoadlevelACWRChartComponent]
})
export class TeamLoadlevelAnalysisComponent implements OnInit {

  constructor(private teamservice: TeamService, private route: ActivatedRoute) {
    this.TeamId = this.route.snapshot.paramMap.get('TeamId');
   }

  teams: TeamDetails[];
  TeamId: string;
  Period: string;

  ngOnInit() {
    this.Period="3+3";
    this.getTeamDetails();
    //console.log("!!!!!");
  }

  

  getTeamDetails(): void{
    this.teamservice.getTeams().subscribe(t => {
      this.teams = t as TeamDetails[];
      });
  }

}
